import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as GreenDot } from "../../assets/icons/greenDotSmall.svg";
import { ReactComponent as LeftArrowIcon } from "../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as AddCategoryBtn } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as DelIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import CreateInvestment1 from "./Forms/createInvestment1";
import InvestmentTimeline from "./InvestmentTimeline";
import { getInvestmentTimeline } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/Close-green.svg"; 
import { ReactComponent as SuccessCheck } from "../../../myfin_v2/assets/icons/successCheck.svg"; 
import { ReactComponent as SortIcon } from "../../../myfin_v2/assets/icons/sort.svg"; 
import RetryIcon from "../../../myfin_v2/assets/icons/Retry.png";
import { Button } from "../../../myfin_v2/elements/Button";
import IRMenu from "./IRMenu";
import Sidebar from "../../../myfin_v2/elements/Sidebar";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";

const tlStyles = {
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginBottom: "20px",
    fontSize: "13px",
    color: "#8FAAA3",
  },
  breadcrumbLink: {
    color: "#4D6D64",
    cursor: "pointer",
    fontWeight: "500",
    textDecoration: "none",
  },
  breadcrumbSep: {
    color: "#C4D8D2",
  },
  breadcrumbActive: {
    color: "#111111",
    fontWeight: "600",
  },
};

const InvestmentData = (props) => {
  const [sortOrder, setSortOrder] = useState(
    localStorage.getItem("timelineSortOrder") || "asc"
  );
  const [timelineData, setTimelineData] = useState([]);
  const [showCreateInvestment, setShowCreateInvestment] = useState(false);
  const [showRestorePopup, setShowRestorePopup] = useState(false);
  const [showConfirmRestoreAll, setShowConfirmRestoreAll] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [deletedItems, setDeletedItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const location = useLocation();
  const history = useHistory();
  
  const b = location.pathname.split("/");
  const registerId = b[2];       
  const investmentPairKey = b[3];     

  useEffect(() => {
    fetchTimeline();
  }, []);

  useEffect(() => {
  if (showSuccessPopup) {
    const timer = setTimeout(() => {
      setShowSuccessPopup(false);  
      setShowRestorePopup(false); 
      setShowConfirmRestoreAll(false); 
    }, 3000); 

    return () => clearTimeout(timer);
  }
}, [showSuccessPopup]);

  const fetchTimeline = async () => {
    try {
      const res = await getInvestmentTimeline(registerId, investmentPairKey);
      if (res.status === 200) {
        setTimelineData(res.data);
      }
    } catch (error) {
      console.error("Timeline fetch error:", error);
    }
  };


  if (showCreateInvestment) {
    return (
      <CreateInvestment1
        registerID={registerId}
        onBack={() => {
          setShowCreateInvestment(false);
          fetchTimeline(); 
        }}
      />
    );
  }

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');`}</style>

      <div className={commoncss.pageLayout}>
        <Sidebar />

        <div className={`d-flex ${commoncss.pageContent}`}>
          <IRMenu activeTab={"Investments"} registerID={registerId} />

          <motion.div
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 0, opacity: 0 }}
            transition={{ duration: 0.45, ease: "easeInOut" }}
            className={investmentRegisterCss.irLayout}
            style={{ display: "flex", flexDirection: "column", gap: 0 }}
          >
            <div className={investmentRegisterCss.iDHeader}>
              <nav style={tlStyles.breadcrumb} aria-label="breadcrumb">
                <LeftArrowIcon height={12} onClick={() => history.goBack()} style={{ cursor: "pointer" }} />

                <span
                  style={{ ...tlStyles.breadcrumbLink, fontSize: "14px", marginRight: "6px" }}
                  onClick={() => history.push(`/detailsIR/${registerId}`)}
                >
                  Investment Register
                </span>

                <span style={{ ...tlStyles.breadcrumbSep, marginRight: "6px" }}>
                  <GreenDot />
                </span>

                <span style={{ ...tlStyles.breadcrumbActive, fontSize: "14px" }}>
                  Investment Timeline
                </span>
              </nav>

             <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "18px",
                alignItems: "center",  
                marginBottom: "16px",
              }}
            >
              <SortIcon 
              className= {`${investmentRegisterCss.sortIcn} ${ sortOrder === "desc" ? investmentRegisterCss.rotate : "" }`}
              onClick={() => {
                const newOrder = sortOrder === "asc" ? "desc" : "asc";
                setSortOrder(newOrder);
                localStorage.setItem("timelineSortOrder", newOrder);
              }}/>
              {/* <Button
                className={investmentRegisterCss.binBtn}
                label={
                  <>
                    <DelIcon className={investmentRegisterCss.delTransIcon} />
                    Bin
                  </>
                  
                }
                onClick={() => setShowRestorePopup(true)}
              /> */}

              <Button
                className={investmentRegisterCss.addTransactionBtn}
                label={
                  <>
                    <AddCategoryBtn />
                    Add Transaction
                  </>
                }
                onClick={() => setShowCreateInvestment(true)}
              />
            </div>
            </div>

            <div className={investmentRegisterCss.iDContainer}>
              <InvestmentTimeline
                investmentID={registerId}
                investmentPairKey={investmentPairKey}
                timelineData={timelineData}
                sortOrder={sortOrder}
                onRefresh={() => fetchTimeline()}
              />
            </div>
          </motion.div>
        </div>
      </div>
        <AnimatePresence>
       {showRestorePopup && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", display: "flex",  justifyContent: "center", alignItems: "center", zIndex: 999 }}>

        <motion.div
          onClick={(e)=>e.stopPropagation()}
          initial={{ y: "100vh", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100vh", opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 50,   
            damping: 14,    
            mass: 1.4     
          }}
          style={{
            width: 720,
            background: "#fff",
            borderRadius: 14,
            padding: 24,
            boxShadow: "0px 20px 40px rgba(0,0,0,0.15)"
          }}
        >

        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>

        <h5>Restore Deleted Items</h5>

        <div
        style={{
        display:"flex",
        alignItems:"center",
        marginLeft:"auto"
        }}
        >

        <button
        onClick={()=>setShowConfirmRestoreAll(true)}
        style={{
        background:"none",
        border:"none",
        color:"#2D8861",
        fontWeight:500,
        cursor:"pointer",
        fontSize:"18px"
        }}
        >
        Restore All
        </button>

        <button
        onClick={()=>setShowRestorePopup(false)}
        style={{
        background:"none",
        border:"none",
        cursor:"pointer"
        }}
        >
        <CloseIcon/>
        </button>

        </div>
        </div>
      
       <div style={{ height:260, overflow:"auto", border:"1px solid #EAEEED", borderRadius:10, padding:0 }}>
       {deletedItems.length === 0 ? (


      <div
      style={{ height:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", color:"#7B8E8A", fontSize:"14px", gap:"8px" }}>

      <p style={{margin:0, fontSize:"15px"}}>Deleted transactions will appear here</p>
      </div>                
                      
      ) : (


    <table style={{width:"100%", borderCollapse:"collapse", fontSize:"14px"}}>

    <thead style={{background:"#F6F9F8", color:"#6A7F7B"}}>

    <tr style={{textAlign:"left"}}>

    <th style={{padding:"10px"}}>
    <input
    type="checkbox"
    onChange={(e)=>{
    if(e.target.checked){
    setSelectedItems(deletedItems.map(i=>i.id))
    }else{
    setSelectedItems([])
    }
    }}
    />
    </th>

    <th>TRANCH NAME</th>
    <th>NATURE OF TRANSACTION</th>
    <th>TRANSACTION DATE</th>
    <th>TRANSACTION VALUE</th>
    <th></th>

    </tr>

    </thead>

    <tbody>

    {deletedItems.map((item)=>(
    <tr key={item.id} style={{borderTop:"1px solid #EAEEED"}}>

    <td style={{padding:"10px"}}>
    <input
    type="checkbox"
    checked={selectedItems.includes(item.id)}
    onChange={()=>{
    setSelectedItems(prev =>
    prev.includes(item.id)
    ? prev.filter(id=>id!==item.id)
    : [...prev,item.id]
    )
    }}
    />
    </td>

    <td>{item.tranch}</td>
    <td>{item.nature}</td>
    <td>{item.date}</td>
    <td>{item.value}</td>

    <td>
    <img
    src={RetryIcon}
    alt="retry"
    width={18}
    style={{cursor:"pointer"}}
    />
    </td>

    </tr>
    ))}

    </tbody>

    </table>

    )}

    </div>

    

        <div style={{
        display:"flex",
        justifyContent:"space-between",
        marginTop:20
        }}>

        <button
        onClick={()=>setShowRestorePopup(false)}
        style={{
        padding:"12px 30px",
        borderRadius: "10px",
        border:"1px solid #A0DABC",
        background:"#fff",
        color: "#205A46",
        fontWeight: 500,
        fontSize: "16px",
        }}
        >
        Cancel
        </button>

        <button
        style={{
        background:"#205A46",
        color:"#fff",
        padding:"12px 30px",
        borderRadius: "10px",
        border: "none",
        }}
        onClick={()=>{
        setShowRestorePopup(false)
        setShowSuccessPopup(true)
        }}
        >
        Restore Selected Items
        </button>

        </div>

        </motion.div>
        </motion.div>
      )}
        </AnimatePresence>

        <AnimatePresence>
        {showConfirmRestoreAll && (
        <motion.div
        initial={{opacity:0}}
        animate={{opacity:1}}
        exit={{opacity:0}}
        style={{
        position:"fixed",
        inset:0,
        background:"rgba(0,0,0,0.35)",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        zIndex:1000
        }}
        >

        <motion.div
        initial={{scale:0.8}}
        animate={{scale:1}}
        transition={{type:"spring", stiffness:180}}
        style={{
        background:"#fff",
        padding:32,
        borderRadius:12,
        textAlign:"center",
        width:420,
        height: 220,
        }}
        >

        <h5 style={{  marginTop: "40px" }}>Do you want to <b>restore</b> all <b>18</b> items?</h5>

        <div style={{marginTop:30, display:"flex", gap:20, justifyContent:"center"}}>

        <button
        style={ {width: "180px", background:"#205A46",fontSize: "18px", color:"#fff", padding:"14px", borderRadius: "12px" , border: "none" }}
        onClick={()=>{
        setShowConfirmRestoreAll(false)
        setShowSuccessPopup(true)
        }}
        >
        <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
          <img src= {RetryIcon} alt="retry" width={24} height={24} />
           Yes, Restore
        </span>
        </button>

        <button onClick={()=>setShowConfirmRestoreAll(false)}
        style={ {width: "140px", background:"#ffffff",fontSize: "18px", color:"#205a46", padding:"14px", borderRadius: "12px" , border: "1px solid #CCD5D3" }}>
        Cancel
        </button>

        </div>

        </motion.div>
        </motion.div>
        )}
        </AnimatePresence>

        <AnimatePresence>
        {showSuccessPopup && (

        <motion.div
        initial={{opacity:0}}
        animate={{opacity:1}}
        exit={{opacity:0}}
        style={{
        position:"fixed",
        inset:0,
        background:"rgba(0,0,0,0.35)",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        zIndex:1100
        }}
        >

        <motion.div
        initial={{scale:0.8}}
        animate={{scale:1}}
        transition={{type:"spring",stiffness:180}}
        style={{
        background:"#fff",
        padding:40,
        borderRadius:16,
        textAlign:"center",
        width: 350,
        }}
        >

        <div
        style={{
        width:70,
        height:70,
        background:"#E6F1EA",
        borderRadius:"50%",
        margin:"auto",
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        fontSize:30
        }}
        >
        <SuccessCheck/>
        </div>

        <h5 style={{marginTop:20}}>Restored Successfully</h5>

        </motion.div>

        </motion.div>

        )}
        </AnimatePresence>
    </>
  );
};

export default InvestmentData;